import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AuthGuardService as LoggedInAuthGuard } from '../guards/logged-in/auth-guard.service'; 
import { FinishedDiscoveryGuardService } from '../guards/finished-discovery/finished-discovery-guard.service';
import { RoleGuardService } from '../guards/role/role-guard.service';
@NgModule({
  declarations: [
  ],
  imports: [
    CommonModule,
    FormsModule
  ],
  providers: [LoggedInAuthGuard, FinishedDiscoveryGuardService, RoleGuardService],
})
export class AuthModule { }
